const initialState = {    
    //invoices search
    clients: [],
    pageSize: 10,
    activePage: 1,    
    loadingClients: true,
    sortDirection: true,
    message: "Molimo pokrenite pretragu",
    search: {
        clientName: "",
        clientAddress: "",
        clientEmail: "",
        clientOIB: "",
        clientPhoneNumber: "",
        clientVAT: "",
        clientDomain: ""        
    },

    posProstorList: [],
    napUredajiList: [],
    articleList: [],
    usersList: [],

    oneClient: [],
    onePosPro: [],
    oneNapUred: [],
    oneArticle: [],
    oneUser: []
};


const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {


    case "ADMIN_MAP_ONE_USER":
        return{
            ...state,
            oneUser: action.data
        }  
            
    case "ADMIN_CHANGE_ONE_USER_DETAILS":
        const userKey = action.data.id
        return{
            ...state,
            oneUser: {
                ...state.oneUser,
                [userKey]: action.data.value
            }
        }

    case "ADMIN_MAP_USERS_LIST":
        return{
            ...state,
            usersList: action.data
        }
        
    case "ADMIN_CHANGE_SEARCH_CLIENT_PARAMETERS":
        const searchParam = action.data.id
        return{
            ...state,
            search: {
                ...state.search,
                [searchParam]: action.data.value
            }
        }

    case "ADMIN_CHANGE_ONE_ARTICLE_DETAILS":
        const articleKey = action.data.id
        return{
            ...state,
            oneArticle: {
                ...state.oneArticle,
                [articleKey]: action.data.value
            }
        }
        
    case "ADMIN_MAP_ONE_ARTICLE":
        return{
            ...state,
            oneArticle: action.data
        }   

    case "ADMIN_CHANGE_ONE_NAPLATNI_UREDAJ_DETAILS":
        const napUredKey = action.data.id
        return{
            ...state,
            oneNapUred: {
                ...state.oneNapUred,
                [napUredKey]: action.data.value
            }
        }
        
    case "ADMIN_MAP_ONE_NAPLATNI_UREDAJ":
        return{
            ...state,
            oneNapUred: action.data
        }

    case "ADMIN_CHANGE_ONE_POSLOVNI_PROSTOR_DETAILS":
        const posProKey = action.data.id
        return{
            ...state,
            onePosPro: {
                ...state.onePosPro,
                [posProKey]: action.data.value
            }
        }

    case "ADMIN_MAP_ONE_POSLOVNI_PROSTOR":
        return{
            ...state,
            onePosPro: action.data
        }

    case "ADMIN_MAP_NAP_URED_LIST":
        return{
            ...state,
            napUredajiList: action.data
        }

    case "ADMIN_MAP_ARTICLE_LIST":
        return{
            ...state,
            articleList: action.data
        }
    

    case "ADMIN_MAP_POS_PRO_LIST":
        return{
            ...state,
            posProstorList: action.data
        }

    case "ADMIN_MAP_ONE_CLIENT_DETAILS":
        return{
            ...state,
            oneClient: action.data
        }

    case "ADMIN_CHANGE_ONE_CLIENT_DETAILS":
        const key = action.data.id
        return{
            ...state,
            oneClient: {
                ...state.oneClient,
                [key]: (action.data.id === "inVatSystem" ?  !state.oneClient.inVatSystem : action.data.value )
            }
        }
       

    case "ADMIN_MAP_CLIENT_LIST_MESSAGE":
        return{
            ...state,
            message: action.data
        }

    case "ADMIN_MAP_CLIENT_LIST":
        return{
            ...state,
            clients: action.data       
        }

    case "ADMIN_MAP_LOADING_CLIENT":
        return{
            ...state,
            loadingClients: action.data        
        }

    case "ADMIN_MAP_CLIENT_LIST_PAGE_SIZE":
        return{
            ...state,
            pageSize: action.data        
        }

    case "ADMIN_MAP_CLIENT_LIST_ACTIVE_PAGE":
        return{
            ...state,
            activePage: action.data        
        }

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
